"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nlToBr = exports.getCurrentYear = void 0;
exports.getCurrentYear = (function () {
    var savedYear = new Date(Date.now()).getFullYear();
    return function () { return savedYear; };
})();
var nlToBr = function (str) { return ((str !== undefined)
    ? str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    : ''); };
exports.nlToBr = nlToBr;
